"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentsContext = exports.GetContent = exports.ContentsProvider = void 0;
var _react = require("react");
const contentsContext = exports.contentsContext = /*#__PURE__*/(0, _react.createContext)({});
const ContentsProvider = exports.ContentsProvider = contentsContext.Provider;
const GetContent = key => {
  const contents = (0, _react.useContext)(contentsContext);
  return contents[key.id] ?? '';
};
exports.GetContent = GetContent;
//# sourceMappingURL=contentsContext.js.map